import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./styles.scss";

const StackedBarChart = ({ data = {}, options = {} }) => {
  const chartComponentRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (chartComponentRef.current) {
        chartComponentRef.current.chart.reflow();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const categories = data?.categories || [];
  const series =
    data?.series?.map((s, index) => {
      const gradients = [
        { from: "#378894ff", to: "#1c383c" },
        { from: "#f7a440ff", to: "#c25b00" },
        { from: "#8e54e9ff", to: "#6915f1ff" },
        { from: "#67a9eaff", to: "#0063C3" },
      ];

      const greyGradient = { from: "#d3d3d3", to: "#808080" };

      const { from, to } =
        s.name?.toLowerCase() === "other"
          ? greyGradient
          : gradients[index % gradients.length];

      return {
        name: s.name,
        data: s.data,
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, from],
            [1, to],
          ],
        },
        borderRadius: 3,
      };
    }) || [];

  const chartOptions = {
    accessibility: {
      enabled: false
    },
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },
    title: {
      text: options?.title,
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#333",
      },
    },
    xAxis: {
      categories,
      labels: {
        style: { fontFamily: "Inter", fontSize: "12px", color: "#444" },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: options?.yAxisTitle || "Total Feedback",
        style: { fontWeight: "600", color: "#333" },
      },
      gridLineColor: "#eee",
    },
    tooltip: {
      shared: false,
      backgroundColor: "#fff",
      borderColor: "#ddd",
      borderRadius: 8,
      shadow: false,
      useHTML: true,
      formatter: function () {
        return `
      <div style="font-family:Inter, sans-serif; font-size:13px;">
        <span style="color:${this.color}"></span> 
        <b>${this.series.name}: </b><b>${this.y}</b><br/><br/>   
      </div>
    `;
      },
    },

    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: { fontSize: "13px", color: "#333" },
      symbolRadius: 3,
    },
    plotOptions: {
      series: {
        stacking: "normal",
        borderWidth: 0,
        groupPadding: 0.1,
        pointPadding: 0.05,
        borderRadius: 3,
        // dataLabels: {
        //   enabled: true,
        //   style: { fontSize: "8px", color: "#000" },
        // },
      },
    },
    series,
    credits: { enabled: false },
  };

  return (
    <div className="bar-chart">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        ref={chartComponentRef}
      />
    </div>
  );
};

export default StackedBarChart;
